import React from 'react';
import { Drawer, Link, DialogContentText, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, List, ListItem, ListItemIcon, ListItemText, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import CookieIcon from '@mui/icons-material/Cookie';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import SecurityIcon from '@mui/icons-material/Security';
import { Trans, useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';

const CookiePromptDialog = ({ open, onAccept, onDecline }: { open: boolean, onAccept: () => void, onDecline: () => void }) => {
	const handleAcceptClick = (e: React.FormEvent) => {
		e.preventDefault();
		onAccept();
	};

	const handleDeclineClick = (e: React.FormEvent) => {
		e.preventDefault();
		onDecline();
	};

	const { t } = useTranslation();
	return <Drawer open={open} anchor='bottom'>
		<form onSubmit={handleAcceptClick}>
			<DialogTitle>
				<Box display='flex' alignItems='center' gap={1}>
					{t('cookiePromptDialog.title')}
					<CookieIcon style={{ fontSize: 24 }} />
				</Box>
			</DialogTitle>
			<DialogContent>
				<DialogContentText sx={{ mb: 2 }}>
					<Trans i18nKey="cookiePromptDialog.description" components={{ 
						privacyPolicyLink: <Link href={t('common.privacyPolicyHref')} target="_blank" />,
						termsOfServiceLink: <Link href={t('common.termsOfServiceHref')} target="_blank" />
					}} />
				</DialogContentText>
				<Accordion sx={{ mb: 2 }}>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography variant="subtitle1" fontWeight="medium">
							{t('cookiePromptDialog.cookieDetails.title')}
						</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<List dense>
							<ListItem>
								<ListItemIcon>
									<SecurityIcon color="primary" />
								</ListItemIcon>
								<ListItemText 
									primary={t('cookiePromptDialog.cookieDetails.essential.title')}
									secondary={t('cookiePromptDialog.cookieDetails.essential.description')}
								/>
							</ListItem>
							<ListItem>
								<ListItemIcon>
									<AnalyticsIcon color="primary" />
								</ListItemIcon>
								<ListItemText 
									primary={t('cookiePromptDialog.cookieDetails.analytics.title')}
									secondary={t('cookiePromptDialog.cookieDetails.analytics.description')}
								/>
							</ListItem>

						</List>
					</AccordionDetails>
				</Accordion>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleDeclineClick} variant='outlined' color='inherit'>
					{t('cookiePromptDialog.decline')}
				</Button>
				<Button type='submit' variant='contained'>
					{t('cookiePromptDialog.accept')}
				</Button>
				<LanguageSwitcher />
			</DialogActions>
		</form>
	</Drawer>;
};
export default CookiePromptDialog;
